import { connect } from 'react-redux';
import FitAndRotate from './fitAndRotate';
import fitToWidthClick from '../../../shared/actions/fitToWidth';
import { rotate } from '../../../shared/actions/rotate';

const mapStateToProps = state => ({
  stayFitToWidth: state.stayFitToWidth,
  activePageIndex: state.activePageIndex,
});

const mapDispatchToProps = dispatch => ({
  fitToWidthClick: () => dispatch(fitToWidthClick()),
  rotate: pageIndex => dispatch(rotate(pageIndex)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FitAndRotate);
